var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2 flex flex-wrap gap-3"},_vm._l((_vm.displayedTags),function(tag,index){return _c('inertia-link',{key:index,staticClass:"bg-primary-color text-white px-2 py-1 rounded-md text-sm cursor-pointer",attrs:{"href":_vm.route+'?search=' + encodeURIComponent(tag),"as":"button"}},[_vm._v("\n    "+_vm._s(tag)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }